
<div [ngClass]="{'timeline-without-navigation': !hasScrollbar}">
  <div class="timeline-bar">
    <ispm-timeline-event-filter
      class="timeline-filter"
      [eventTypes]="eventTypes"
      (filterChange)="filterEvents($event)"
    ></ispm-timeline-event-filter>
  </div>
  <div *ngIf="hasScrollbar && config?.showNavIcons && eventMappedData && eventMappedData.length > 0"
       class="timeline-action-buttons">
    <i class="fa fa-chevron-left"
       (click)="scrollBackward()">
    </i>
  </div>
  <section #timelinePanel
           *ngIf="eventMappedData && eventMappedData.length > 0;else no_events_content"
           class="timeline-event-wrapper"
           [ngStyle]="{
         'width': config?.width,
         'height': config?.height,
         'overflow-x': config?.showNavIcons ?'hidden': 'auto' }"
           horizontalMouseWheel
           [ngClass]="config?.cssClass"
           (window:resize)="onResizeTimeline()">
    <dls-timeline [model]="events" (eventClick)="onEventSelect($event)"></dls-timeline>
  </section>
  <div *ngIf="hasScrollbar && config?.showNavIcons && eventMappedData && eventMappedData.length > 0"
       class="timeline-action-buttons">
    <i class="fa fa-chevron-right"
       (click)="scrollForward()">
    </i>
  </div>
  <gen-overlay-loader class="loader" *ngIf="!timelineLoaded" [loaderType]="'SKELETON-PLAIN'" [showOverlay]="false"></gen-overlay-loader>
</div>
<ng-template #no_events_content>
  <section *ngIf="timelineLoaded"
           [ngClass]="config?.cssClass"
           class="timeline-event-wrapper timeline-no-events-wrapper">
    <span>{{ 'NO_EVENTS' | translate }}</span>
  </section>
</ng-template>

